import SingleFAQ from "./SingleFAQ";

const FAQ = () => {
  return (
    <section className="bg-white">
      <div className="faqs-wrapper px-3 text-[#414141]">
        <div className="title text-3xl">
          <h2>Frequently Asked Questions</h2>
        </div>
        <div className="faqs-list text-base p-3">
          <SingleFAQ question={"What is Gepzo Box?"}>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged. It was popularized
          </SingleFAQ>
          <SingleFAQ question={"How do I buy a Gepzo membership?"}>
            is simply dummy text of the printing and typesetting industry. Lorem
            Ipsum has been the industry's standard dummy text ever since the
            1500s, when an unknown printer took a galley of type and scrambled
            it to make a type specimen book. It has survived not only five
            centuries, but also the leap into electronic typesetting, remaining
            essentially unchanged. It was popularised is simply dummy text of
            the printing and typesetting industry. Lorem Ipsum has been the
            industry's standard dummy text ever since the 1500s, when an unknown
            printer took a galley of type and scrambled it to make a type
            specimen book. It has survived not only five centuries, but also the
            leap into electronic typesetting, remaining essentially unchanged.
            It was popularised
          </SingleFAQ>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
